import { CancelPrescribedMedicationModal } from '@/components/PatientPageV2/components/CancelPrescribedMedicationModal/CancelPrescribedMedicationModal';
import { PrescribeErrorModal } from '@/components/PatientPageV2/components/PrescribeErrorModal/PrescribeErrorModal';
import { PrescriptionPadWrapper } from '@/components/PatientPageV2/components/PrescriptionPad';
import { useSubmitCancelPrescribedMedications } from '@/hooks/prescribedProducts/useSubmitCancelPrescribedMedications';
import { PrescriptionAssistantModal } from '@/shared-ui/PrescriptionAssistantModal/PrescriptionAssistantModal';
import { useAppStore } from '@/state-management';
import { Stack } from '@mui/material';
import type { PrescriptionAssistantToolProps } from './PrescriptionAssistantTool.types';

export const PrescriptionAssistantTool = ({
  isPostingPrescription,
  prescriptionDetails,
  showPrescribeStateError,
  onPrescriptionErrorClosed,
  onOnlyCancelComplete,
}: PrescriptionAssistantToolProps) => {
  const { doctorId, patientId, prescriberNumber, doctor, patient } = prescriptionDetails;

  const {
    prescriptionPad: { medicationPadItems: medicationPadItems, showCancellation },
  } = useAppStore.use.prescriptionAssistant();
  const advancePrescriptionPadStep = useAppStore.use.advancePrescriptionPadStep();
  const updateShowCancellation = useAppStore.use.updateShowCancellation();

  const { submitCancelPrescribedMedications, isLoading: isCancellingPrescriptions } =
    useSubmitCancelPrescribedMedications();

  const handleCancelMedications = async () => {
    // refetch previous medications
    const isOnlyCancellingMedications = !medicationPadItems[0]?.medicationPadItem?.productName;
    if (isOnlyCancellingMedications) {
      await onOnlyCancelComplete?.();
    } else {
      // Doctor is both cancelling and prescribing medications
      advancePrescriptionPadStep();
    }

    updateShowCancellation(false);
  };

  if (!patientId || !doctorId) {
    return;
  }

  return (
    <Stack data-testid="prescription-assistant-tool">
      <PrescriptionPadWrapper
        doctorId={doctorId}
        patientId={patientId}
        prescriberNumber={prescriberNumber}
        doctorPatientDetails={{
          doctor: doctor,
          patient: patient,
        }}
      />
      <PrescriptionAssistantModal
        open={isPostingPrescription}
        isLoading={true}
        loadingTitle="Creating prescription..."
        loadingBody="Please wait, this may take a moment."
        title=""
        onConfirm={() => {}}
      />
      <CancelPrescribedMedicationModal
        isOpen={showCancellation}
        onClose={() => updateShowCancellation(false)}
        onConfirm={() => submitCancelPrescribedMedications(patientId.toString(), handleCancelMedications)}
        isLoading={isCancellingPrescriptions}
      />
      <PrescribeErrorModal open={showPrescribeStateError} onConfirm={onPrescriptionErrorClosed} />
    </Stack>
  );
};
